import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, of } from 'rxjs';
import { InfoService } from '@wonder-core-ng/info-store/info.service';
import { QueryEngineApiService } from '../query-engine/query-engine.api.service';
import { QueryConfigActions } from './query-config.actions';

@Injectable()
export class QueryConfigEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(QueryEngineApiService);
  private readonly infoService = inject(InfoService);

  saveQueryConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(QueryConfigActions.saveQueryConfig),
      concatMap(({ queryConfigData, tenantId }) =>
        this.api.saveQueryConfig(queryConfigData, tenantId).pipe(
          map((savedQueryConfig) => {
            this.infoService.addMessage({
              message: 'Query generated and saved successfully',
              severity: 'success',
            });
            // Carry the server-assigned id back (the form uses it to switch to edit mode + URL).
            return QueryConfigActions.saveQueryConfigSuccess({
              queryConfigData: { ...queryConfigData, id: savedQueryConfig?.id ?? queryConfigData.id },
            });
          }),
          catchError((error) => {
            this.infoService.addMessage({
              message: 'Error saving query config',
              severity: 'error',
            });
            return of(QueryConfigActions.saveQueryConfigFailure({ error }));
          })
        )
      )
    );
  });
}
